module.exports = __webpack_public_path__ + "static/media/DOUBLE-WELTED X3.4c28a985.svg";